import React from "react";
import {
  XMarkIcon,
  TrashIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";
import twFocusClass from "utils/twFocusClass";

export interface ButtonCloseProps {
  className?: string;
  onClick?: () => void;
  icon?: string;
}

const ButtonClose: React.FC<ButtonCloseProps> = ({
  className = "",
  icon = "close",
  onClick = () => {},
}) => {
  return (
    <button
      className={
        `w-8 h-8 flex items-center justify-center rounded-full text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 ${className} ` +
        twFocusClass()
      }
      onClick={onClick}
    >
      <span className="sr-only">Close</span>
      {icon && icon === "delete" ? (
        <TrashIcon className="w-5 h-5" />
      ) : icon === "edit" ? (
        <PencilSquareIcon className="w-5 h-5" />
      ) : (
        <XMarkIcon className="w-5 h-5" />
      )}
    </button>
  );
};

export default ButtonClose;
